import React from "react";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";

const features = [
  { title: 'Multilingual Support', detail: 'Whether using English or Urdu, Aasaann adapts to preferred language, making it easy to navigate and manage the business in the language most comfortable.', icon: '1.png' },
  { title: 'Manage Accounts & Balances', detail: 'Track business finances effortlessly. Aasaann provides real-time account balance updates, ensuring a clear view of the business’s financial standing.', icon: '2.png' },
  { title: 'General Register', detail: 'Keep all important transactions, purchases, and sales recorded in a digital, easy-to-use register. Say goodbye to paperwork and stay organized with digital records.', icon: '3.png' },
  { title: 'Cashbook', detail: 'Monitor cash inflow and outflow in real-time. Track payments, receipts, and other cash-related transactions through a simple, user-friendly interface.', icon: '1.png' },
  { title: 'Reports & Bills', detail: 'Generate detailed reports and bills in seconds. Whether it’s sales data, purchase details, or payment history, creating and exporting reports is a breeze.', icon: '1.png' },
  { title: 'Purchaser Management', detail: 'Manage purchasers, including contact details, transactions, and payment histories, all in one place.', icon: '1.png' },
  { title: 'Farmer Management', detail: 'Add and manage farmers, track their contributions, and maintain seamless connections with suppliers.', icon: '1.png' }
]

const ServiceAreaThree = () => {
  return (
    <>
      {/*=================== service area start ===================*/}
      <div className='service-area bg-relative pd-top-120 pd-bottom-90' id="features">
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-xl-8 col-lg-10'>
              <div className='section-title text-center'>
                <h6 className='sub-title'>KEY FEATURES</h6>
                <h2 className='title'>
                  Best Destination To Get Your Own <span>Application</span>{" "}
                  Developed
                </h2>
              </div>
            </div>
          </div>
          <div className='row g-4'>
            {features.map((feature, i) => (
              <div key={i} className='col-lg-4 col-md-6'>
                <div className='single-service-inner style-3 h-100'>
                  <div className='thumb'>
                    <img src={`assets/img/service-icon/${feature.icon}`} alt='img' />
                  </div>
                  <div className='details'>
                    <h5>
                      <Link to='/service-details'>{feature.title}</Link>
                    </h5>
                    <p>
                      {feature.detail}
                    </p>
                    {/* <Link className='read-more-text' to='/service-details'>
                      Touch More <FaPlus />
                    </Link> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* =================== service area end ===================*/}
    </>
  );
};

export default ServiceAreaThree;
